/**
 * Booking Number Formatter.
 * @param {*} value
 * @param {*} row
 * @returns {string}
 */
window.bookingNumberFormatter = function(value, row) {
    let html = '';
    if (rights.includes("bookings.show")) {
        if (value) {
            html = '<a href="/bookings/show/'+row.booking_id+'">'+value+'</a>';
        } else {
            html = '<a href="/bookings/show/'+row.booking_id+'">'+__('details')+'</a>';
        }
    } else if (value) {
        html = value;
    }
    return html;
};
